import React, { useRef, useState,useMemo } from "react";
import {  Col, Form, InputGroup, Modal, Row } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Fontstyling from "../../components/common/comman";
import { useEffect } from "react";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { useSelector } from "react-redux";
import "./style.css";
import { DateRangePicker } from "rsuite";
import moment from "moment/moment";
import ReactTooltip from "react-tooltip";
import {
  DeleteCedarGeteForm,
  DownloadCedarGeteForm,
  GetAnalyticsFunding,
  GetCedarGeteForm,
  GetDentalFunding,
  GetMedicalfunding,
  SaveCedarGateFormData,
  UpdateCedarGateFormData,
  GetSalesForceVendorList
} from "../../api/User/CedarGate/cedarGateFormApi";
import CustomReactMaterialTable from "../../components/common/CustomReactMaterialTable";
import toastFile from "../../Service/ToastFile";
import DeleteModal from "../../components/common/Modal/DeleteModal";
import CustomButton from "../../components/common/CustomButton";
import Required from "../../components/Required";
import {
  getClientsDatabyPaginationbySearch,
  getRegionDetail,
} from "../../api/User/commonApi";
import {
  GetIndustry,
  getCompanySize,
} from "../../api/User/Hub/companysetupApi";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
const schema = Yup.object().shape({
  // client_Name: Yup.object().notOneOf(
  //   ["0", null, "", 0, undefined],
  //   "Please select Client Name"
  // ),
  benefit_Point_ID: Yup.string().required("Please enter Benefit Point ID"),
  client_Name: Yup.string().required("Please enter Client Name"),
  Clientdba: Yup.string().required("Please enter Client DBA"),
  ZipCode: Yup.string().required("Please enter Zip Code"),
  Industry: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please select SIC Sub Industry")
    .required("Please select SIC Sub Industry"),
  GroupType: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please select Group Type")
    .required("Please select Group Type"),
  hubSuperRegion: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please select HUB Super Region")
    .required("Please select HUB Super Region"),
  hubRegion: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please select HUB Region")
    .required("Please select HUB Region"),
  hubLocalRegion: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please select HUB Local")
    .required("Please select HUB Local"),
  HUBContactName: Yup.string().required("Please enter HUB Contact Name"),
  EligibilityVendor: Yup.string().required("Please select Eligibility Vendor"),
  EligibilityHistoricalOngoingTimePeriod: Yup.array()
    .nonNullable("Please select Eligibility Time Period")
    .required("Please select Eligibility Time Period"),
  EligibilityContactName: Yup.string().required(
    "Please enter Eligibility Contact Name"
  ),
  EligibilityContactEMail: Yup.string()
    .email("Please enter valid E-mail")
    .required("Please enter Eligibility Contact E-mail"),
  EligibilityContactPhone: Yup.number()
    .typeError("That doesn't look like a phone number")
    .positive("A phone number can't start with a minus")
    .integer("A phone number can't include a decimal point")
    .required("Please enter Eligibility Contact Phone"),
  MedicalVendor: Yup.string().required("Please select Medical Vendor"),
  MedicalClaimsHistoricalOngoingTimePeriod: Yup.array()
    .nonNullable("Please select Medical Claims Time Period")
    .required("Please select Medical Claims Time Period"),
  MedicalContactName: Yup.string().required(
    "Please enter Medical Contact Name"
  ),
  MedicalContactEMail: Yup.string()
    .email("Please enter valid E-mail")
    .required("Please enter Medical Contact E-mail"),
  MedicalContactPhone: Yup.number()
    .typeError("That doesn't look like a phone number")
    .positive("A phone number can't start with a minus")
    .integer("A phone number can't include a decimal point")
    .required("Please enter Medical Contact Phone"),
  MedicalFundingType: Yup.string()
    .notOneOf(
      ["0", null, "", 0, undefined],
      "Please select Medical Funding Type"
    )
    .required("Please select Medical Funding Type"),
  StopLossReinsurer: Yup.string().required(
    "Please enter Stop Loss / Reinsurer"
  ),
  StopLossReinsurerContractType: Yup.string().required(
    "Please enter Stop Loss / Reinsurer Contract Type"
  ),
  StopLossReinsurerRenewalDate: Yup.string().required(
    "Please select Stop Loss / Reinsurer Renewal Date"
  ),
  ISLLimitPoolingPoint: Yup.number()
    .typeError("Please enter number")
    .max(
      9999999999999,
      "Please enter ISL Limit / Pooling Point less then 1 Trillion"
    )
    .required("Please enter ISL Limit / Pooling Point"),
  AnalyticsFunding: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please select Analytics Funding")
    .required("Please select Analytics Funding"),
  ClinicalConsulting: Yup.string()
    .notOneOf(
      ["0", null, "", 0, undefined],
      "Please select Clinical Consulting"
    )
    .required("Please select Clinical Consulting"),
  RxVendor: Yup.string().required("Please select Rx Vendor"),
  RxClaimsHistoricalOngoingTimePeriod: Yup.array()
    .nonNullable("Please select Rx Claims Time Period")
    .required("Please select Rx Claims Time Period"),
  RxContactName: Yup.string().required("Please enter Rx Contact Name"),
  RxContactEMail: Yup.string()
    .email("Please enter valid E-mail")
    .required("Please enter Rx Contact E-mail"),
  RxContactPhone: Yup.number()
    .typeError("That doesn't look like a phone number")
    .positive("A phone number can't start with a minus")
    .integer("A phone number can't include a decimal point")
    .required("Please enter Rx Contact Phone"),
  OtherVendor: Yup.string().required("Please select Other Vendor"),
  OtherContactName: Yup.string().required("Please enter Other Contact Name"),
  OtherContactEMail: Yup.string()
    .email("Please enter valid E-mail")
    .required("Please enter Other Contact E-mail"),
  OtherContactPhone: Yup.number()
    .typeError("That doesn't look like a phone number")
    .positive("A phone number can't start with a minus")
    .integer("A phone number can't include a decimal point")
    .required("Please enter Other Contact Phone"),
  DentalVendor: Yup.string().required("Please select Dental Vendor"),
  DentalContactName: Yup.string().required("Please enter Dental Contact Name"),
  DentalContactEMail: Yup.string()
    .email("Please enter valid E-mail")
    .required("Please enter Dental Contact E-mail"),
  DentalContactPhone: Yup.number()
    .typeError("That doesn't look like a phone number")
    .positive("A phone number can't start with a minus")
    .integer("A phone number can't include a decimal point")
    .required("Please enter Dental Contact Phone"),
  DentalFundingType: Yup.string()
    .notOneOf(
      ["0", null, "", 0, undefined],
      "Please select Dental Funding Type"
    )
    .required("Please select Dental Funding Type"),
  VisionVendor: Yup.string().required("Please select Vision Vendor"),
  VisionContactName: Yup.string().required("Please enter Vision Contact Name"),
  VisionContactEMail: Yup.string()
    .email("Please enter valid E-mail")
    .required("Please enter Vision Contact E-mail"),
  VisionContactPhone: Yup.number()
    .typeError("That doesn't look like a phone number")
    .positive("A phone number can't start with a minus")
    .integer("A phone number can't include a decimal point")
    .required("Please enter Vision Contact Phone"),
  VisionFundingType: Yup.string()
    .notOneOf(
      ["0", null, "", 0, undefined],
      "Please select Vision Funding Type"
    )
    .required("Please select Vision Funding Type"),
  BenefitsRenewalDate: Yup.string().required(
    "Please select Benefits Renewal Date"
  ),
  EstEEHeadcount: Yup.number()
    .typeError("Please enter number")
    .integer("Please enter integer number")
    .max(
      9999999999999999,
      "Please enter Est. EE Headcount less then 1 Quadrillion"
    )
    .required("Please enter Est. EE Headcount"),
  EstMbrHeadcount: Yup.number()
    .typeError("Please enter number")
    .integer("Please enter integer number")
    .max(
      9999999999999999,
      "Please enter Est. Mbr Headcount less then 1 Quadrillion"
    )
    .required("Please enter Est. Mbr Headcount"),
  CompanySize: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please select Company Size")
    .required("Please select Company Size"),
  ArtemisExpDate: Yup.string().required("Please select Artemis Exp Date"),
  TransitionStatus: Yup.string().required("Please enter Transition Status"),
  ImplementationStatus: Yup.string().required(
    "Please enter Implementation Status"
  ),
  TermedArtemisNoPreviousSystem: Yup.string().required(
    "Please enter Termed Artem is No Previous System"
  ),
  EOMDeadlineImpl: Yup.string().required("Please enter EOM Deadline Impl."),
  CGTNotified: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please select CGT Notified")
    .required("Please select CGT Notified"),
  CGTDateCompleted: Yup.string().required("Please select CGT Date Completed"),
  CGTNoticeEligibility: Yup.string()
    .notOneOf(
      ["0", null, "", 0, undefined],
      "Please select select CGT Notice Eligibility"
    )
    .required("Please select CGT Notice Eligibility"),
  CGTNoticeMedical: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please CGT Notice Medical")
    .required("Please select CGT Notice Medical"),
  CGTNoticeRx: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please CGT Notice Rx")
    .required("Please select CGT Notice Rx"),
  CGTNoticeOther: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please CGT Notice Other")
    .required("Please select CGT Notice Other"),
  CGTNoticeDental: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please CGT Notice Dental")
    .required("Please select CGT Notice Dental"),
  CGTNoticeVision: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please CGT Notice Vision")
    .required("Please select CGT Notice Vision"),
  WrapNetworkSubContractedNetwork: Yup.string().required(
    "Please enter Wrap Network Sub Contracted Network."
  ),
  DomesticIncentive: Yup.string().required("Please enter Domestic Incentive."),
  ASLLimitPoolingPoint: Yup.number().required(
    "Please enter ASL Limit Pooling Point."
  ),
  AnalyticsFundingContactName: Yup.string().required(
    "Please enter Analytics Funding Contact Name."
  ),
  AnalyticsFundingContactEMailAddress: Yup.string()
    .email("Please enter valid E-mail")
    .required("Please enter Analytics Funding Contact E-Mail Address"),
  AnalyticsFundingContactPhoneNumber: Yup.string().required(
    "Please enter Analytics Funding Contact Phone Number."
  ),
  SecondndEligibilityHistoricalOngoingTimePeriod: Yup.array()
    .nonNullable("Please enter 2nd Eligibility Historical Ongoing Time Period")
    .required("Please enter 2nd Eligibility Historical Ongoing Time Period"),
  OtherVendor2: Yup.string().required("Please select Other Vendor 2"),
  OtherContactName2: Yup.string().required("Please enter Other Contact Name 2"),
  OtherContactEmail2: Yup.string()
    .email("Please enter valid E-mail")
    .required("Please enter Other Contact Email 2"),

  OtherContactPhone2: Yup.string().required(
    "Please enter Other Contact Phone 2"
  ),
  SLCarrierFundingNotice: Yup.string()
    .notOneOf(
      ["0", null, "", 0, undefined],
      "Please select SL Carrier Funding Notice"
    )
    .required("Please select SL Carrier Funding Notice"),
  ClientEmailReceived: Yup.string()
    .notOneOf(
      ["0", null, "", 0, undefined],
      "Please select Client Email Received"
    )
    .required("Please select Client Email Received"),
  NDAReceived: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please select NDA Received")
    .required("Please select NDA Received"),
  LOIReceived: Yup.string()
    .notOneOf(["0", null, "", 0, undefined], "Please select LOI Received")
    .required("Please select LOI Received"),
  GoLiveDate: Yup.string().required("Please select Go Live Date"),
  InnovuTermDate: Yup.string().required("Please select Innovu TermDate"),
  Notes: Yup.string().required("Please enter Notes"),
});

const customStyles = {
  control: (base) => ({
    ...Fontstyling.primaryparagraph,
    display: "flex",
    alignItems: "center",
    border: "1px solid #ced4da",
    borderRadius: "0px",
    width: "100%",
    minHeight: "28px",
    maxHeight: "28px",
    textAlign: "left",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      ...Fontstyling.primaryparagraph,
      textAlign: "left",
      backgroundColor: data.value === 0 ? "#fff" : isFocused ? "#3498ff" : null,
      color: data.value === 0 ? "#808080" : isFocused ? "white" : "#212529",
      fontSize: 12,
      paddingTop: 0,
      paddingBottom: 0,
    };
  },
};

export const ListOfCDTGroup = ({ navigate }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const UD_id = useSelector((state) => state.userDetails.value?.UD_id);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isGetData, setIsGetData] = useState(false);
  const buttonRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const user = useSelector((state) => state.userDetails.value);
  const client = useSelector((state) => state.clientData.value);
  const [clientData, setClientData] = useState([]);
  const [isFocus, setIsFocus] = useState(false);
  const [regionDropdownData, setRegionDropdownData] = useState({
    allRegion: [],
    superRegion: [],
    localRegion: [],
    region: [],
  });

  const [DropdownData, setDropdownData] = useState({
    industryData: [],
    MedicalFundingType: [],
    AnalyticsFunding: [],
    DentalAndVisionFundingType: [],
    CompanySize: [],
    VendorList: []
  });
  const location = useLocation();
  useEffect(() => {
    Promise.all([
      GetIndustry(),
      GetMedicalfunding(),
      getCompanySize(),
      GetDentalFunding(),
      GetAnalyticsFunding(),
      GetSalesForceVendorList()
    ]).then(
      ([IndustryRes, fundingRes, groupsizeRes, dentalRes, analyticsRes, vendorRes]) => {
        const sortedFundingTypes = fundingRes.data.data.sort((a, b) =>
          a.MedicalFundingName.localeCompare(b.MedicalFundingName)
        );
        const sortedIndustry = IndustryRes.data.sort((a, b) =>
          a.IndustryName.localeCompare(b.IndustryName)
        );
        const sortedDental = dentalRes.data.data.sort((a, b) =>
          a.DentalFundingName.localeCompare(b.DentalFundingName)
        );
        const sortedAnalytics = analyticsRes.data.data.sort((a, b) =>
          a.AnalyticsFundingName.localeCompare(b.AnalyticsFundingName)
        );
       
        setDropdownData((prev) => ({
          ...prev,
          MedicalFundingType: sortedFundingTypes,
          industryData: sortedIndustry,
          CompanySize: groupsizeRes.data,
          AnalyticsFunding: sortedAnalytics,
          DentalAndVisionFundingType: sortedDental,
          VendorList:vendorRes.data.data
        }));
      }
    );
    getRegionData();
  }, []);

  const getRegionData = async () => {
    await getRegionDetail()
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          setRegionDropdownData((prev) => ({
            ...prev,
            allRegion: res.data,
            superRegion: [...new Set(res.data.map((el) => el.hubSuperRegion))]
              .filter((item) => item !== "NATIONAL")
              .sort(),
          }));
        }
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  const setRegionData = async (action) => {
    if (action) {
      setRegionDropdownData((prev) => ({
        ...prev,
        region: [
          ...new Set(
            prev.allRegion
              .filter(
                (el) => el.hubSuperRegion === selectedRowData?.HUB_Super_Region
              )
              .map((el2) => el2.hubRegion)
          ),
        ].sort(),
        localRegion: [
          ...new Set(
            prev.allRegion.filter(
              (el) => el.hubRegion === selectedRowData?.HUB_Region
            )
          ),
        ].sort(),
      }));
    } else {
      setRegionDropdownData((prev) => ({
        ...prev,
        region: [],
        localRegion: [],
      }));
    }
  };

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    if (searchQuery.length > 3 || searchQuery?.length === 0) {
      try {
        let response = await getClientsDatabyPaginationbySearch(
          user.UD_id,
          page,
          searchQuery
        );
        const data = await response.data.clientsDataModelUDid;
        setClientData([...clientData, ...data]);
        const newOptions = data.map((port) => ({
          value: port.clientID,
          label: port.clientName,
        }));
        return {
          options: newOptions,
          hasMore: newOptions.length >= 1,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        return {
          options: [],
          hasMore: false,
          additional: {
            page: page,
          },
        };
      }
    } else {
      return {
        options: [{ value: 0, label: "Please type at least 4 characters" }],
        hasMore: false,
        additional: {
          page: page,
        },
      };
    }
  };

  const ConvertDateFromate = (value) => {
    return (
      moment(value[0]).format("MM/DD/yyy") +
      "-" +
      moment(value[1]).format("MM/DD/yyy")
    );
  };

  const onSubmit = (values, { resetForm }) => {
    const {
      CedarGateFormID,
      client_Name,
      benefit_Point_ID,
      Clientdba,
      ZipCode,
      Industry,
      GroupType,
      hubSuperRegion,
      hubRegion,
      hubLocalRegion,
      NewHUBLocalName,
      HUBContactName,
      EligibilityVendor,
      EligibilityHistoricalOngoingTimePeriod,
      EligibilityContactName,
      EligibilityContactEMail,
      EligibilityContactPhone,
      MedicalVendor,
      MedicalClaimsHistoricalOngoingTimePeriod,
      MedicalContactName,
      MedicalContactEMail,
      MedicalContactPhone,
      MedicalNetwork1,
      MedicalNetwork2,
      MedicalNetwork3,
      MedicalNetwork4,
      MedicalNetwork5,
      MedicalFundingType,
      StopLossReinsurer,
      StopLossReinsurerContractType,
      StopLossReinsurerRenewalDate,
      ISLLimitPoolingPoint,
      AnalyticsFunding,
      ClinicalConsulting,
      RxVendor,
      RxClaimsHistoricalOngoingTimePeriod,
      RxContactName,
      RxContactEMail,
      RxContactPhone,
      FormularyName1,
      FormularyName2,
      OtherVendor,
      OtherContactName,
      OtherContactEMail,
      OtherContactPhone,
      DentalVendor,
      DentalContactName,
      DentalContactEMail,
      DentalContactPhone,
      DentalFundingType,
      VisionVendor,
      VisionContactName,
      VisionContactEMail,
      VisionContactPhone,
      VisionFundingType,
      BenefitsRenewalDate,
      EstEEHeadcount,
      EstMbrHeadcount,
      CompanySize,
      ArtemisExpDate,
      TransitionStatus,
      ImplementationStatus,
      TermedArtemisNoPreviousSystem,
      EOMDeadlineImpl,
      CGTNotified,
      CGTDateCompleted,
      CGTNoticeEligibility,
      CGTNoticeMedical,
      CGTNoticeRx,
      CGTNoticeOther,
      CGTNoticeDental,
      CGTNoticeVision,
      WrapNetworkSubContractedNetwork,
      DomesticIncentive,
      ASLLimitPoolingPoint,
      AnalyticsFundingContactName,
      AnalyticsFundingContactEMailAddress,
      AnalyticsFundingContactPhoneNumber,
      SecondndEligibilityHistoricalOngoingTimePeriod,
      OtherVendor2,
      OtherContactName2,
      OtherContactEmail2,
      OtherContactPhone2,
      SLCarrierFundingNotice,
      ClientEmailReceived,
      NDAReceived,
      LOIReceived,
      GoLiveDate,
      InnovuTermDate,
      Notes,
      DateTicketSubmittedtoCGT,
    } = values;
    let payload = {
      CedarGateFormID: CedarGateFormID,
      userdetailID: user?.UD_id,
      benefit_Point_ID: benefit_Point_ID,
      client_Name: client_Name,
      client_DBA: Clientdba,
      client_Headquarters_Zip_Code: ZipCode,
      siC_Sub_Industry: Industry,
      group_Type: GroupType,
      huB_Super_Region: hubSuperRegion,
      huB_Region: hubRegion,
      huB_Local: hubLocalRegion,
      new_HUB_Local_Name: NewHUBLocalName,
      huB_Contact_Name: HUBContactName,
      eligibility_Vendor: EligibilityVendor,
      eligibility_Historical: ConvertDateFromate(
        EligibilityHistoricalOngoingTimePeriod
      ),
      eligibility_Contact_Name: EligibilityContactName,
      eligibility_Contact_EMail: EligibilityContactEMail,
      eligibility_Contact_Phone: EligibilityContactPhone,
      medical_Vendor: MedicalVendor,
      medical_Claims_Historical: ConvertDateFromate(
        MedicalClaimsHistoricalOngoingTimePeriod
      ),
      medical_Contact_Name: MedicalContactName,
      medical_Contact_EMail: MedicalContactEMail,
      medical_Contact_Phone: MedicalContactPhone,
      medical_Network_1: MedicalNetwork1,
      medical_Network_2: MedicalNetwork2,
      medical_Network_3: MedicalNetwork3,
      medical_Network_4: MedicalNetwork4,
      medical_Network_5: MedicalNetwork5,
      medical_Funding_Type: MedicalFundingType,
      stop_Loss_Reinsurer: StopLossReinsurer,
      stop_Loss_Reinsurer_Contract_Type: StopLossReinsurerContractType,
      stop_Loss_Reinsurer_Renewal: StopLossReinsurerRenewalDate,
      isL_Limit_Pooling_Point: +ISLLimitPoolingPoint,
      analytics_Funding: AnalyticsFunding,
      clinical_Consulting: ClinicalConsulting,
      rX_Vendor: RxVendor,
      rX_Claims_Historical_Ongoing_Time_Period: ConvertDateFromate(
        RxClaimsHistoricalOngoingTimePeriod
      ),
      rx_Contact_Name: RxContactName,
      rx_Contact_EMail: RxContactEMail,
      rx_Contact_Phone: RxContactPhone,
      formulary_Name_1: FormularyName1,
      formulary_Name_2: FormularyName2,
      other_Vendor: OtherVendor,
      other_Contact_Name: OtherContactName,
      other_Contact_EMail: OtherContactEMail,
      other_Contact_Phone: OtherContactPhone,
      dental_Vendor: DentalVendor,
      dental_Contact_Name: DentalContactName,
      dental_Contact_EMail: DentalContactEMail,
      dental_Contact_Phone: DentalContactPhone,
      dental_Funding_Type: DentalFundingType,
      vision_Vendor: VisionVendor,
      vision_Contact_Name: VisionContactName,
      vision_Contact_EMail: VisionContactEMail,
      vision_Contact_Phone: VisionContactPhone,
      vision_Funding_Type: VisionFundingType,
      benefits_Renewal_Date: BenefitsRenewalDate,
      est_EE_Headcount: +EstEEHeadcount,
      est_Mbr_Headcount: +EstMbrHeadcount,
      company_Size: CompanySize,
      artemis_Exp_Date: ArtemisExpDate,
      transition_Status: TransitionStatus,
      implementation_Status: ImplementationStatus,
      termed_Artemis: TermedArtemisNoPreviousSystem,
      eoM_Deadline: EOMDeadlineImpl,
      cgT_Notified: CGTNotified,
      cgT_Date_Completed: CGTDateCompleted,
      cgT_Notice_Eligibility: CGTNoticeEligibility,
      cgT_Notice_Medical: CGTNoticeMedical,
      cgT_Notice_Rx: CGTNoticeRx,
      cgT_Notice_Other: CGTNoticeOther,
      cgT_Notice_Dental: CGTNoticeDental,
      cgT_Notice_Vision: CGTNoticeVision,
      wrap_Network: WrapNetworkSubContractedNetwork,
      domestic_Incentive: DomesticIncentive,
      asL_Limit_Pooling_Point: ASLLimitPoolingPoint,
      analytics_Funding_Contact_Name: AnalyticsFundingContactName,
      analytics_Funding_Contact_Email: AnalyticsFundingContactEMailAddress,
      analytics_Funding_Contact_Phone: AnalyticsFundingContactPhoneNumber,
      second_Eligibility_Historical: ConvertDateFromate(
        SecondndEligibilityHistoricalOngoingTimePeriod
      ),
      other_Vendor2: OtherVendor2,
      other_Contact_Name2: OtherContactName2,
      other_Contact_Email2: OtherContactEmail2,
      other_Contact_Phone2: OtherContactPhone2,
      sL_Carrier_Funding_Notice: SLCarrierFundingNotice,
      client_Email_Received: ClientEmailReceived,
      ndA_Received: NDAReceived,
      loI_Received: LOIReceived,
      go_Live_Date: GoLiveDate,
      innovu_Term_Date: InnovuTermDate,
      notes: Notes,
      date_Ticket_Submitted_to_CGT: new Date(),
    };
    if (witchAction === "add") {
      SaveCedarGateFormData(payload).then((res) => {
        if (res.data?.issuccess) {
          toastFile(res.data?.message, "success");
          setShowModal(false);
          GetData();
          resetForm();
        } else {
          toastFile(res.data?.message, "error");
        }
      });
    } else if (witchAction === "update") {
      UpdateCedarGateFormData(payload).then((res) => {
        if (res.data?.issuccess) {
          toastFile(res.data?.message, "success");
          setShowModal(false);
          GetData();
        } else {
          toastFile(res.data?.message, "error");
        }
      });
    }
  };

  const ConvertFromateDate = (value) => {
    return value?.map((dateString) => {
      const [month, day, year] = dateString.split("/");
      return new Date(year, month - 1, day);
    });
  };

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    resetForm,
    values,
    touched,
    errors,
  } = useFormik({
    enableReinitialize: true,
    validationSchema: schema,
    onSubmit: onSubmit,
    initialValues: {
      CedarGateFormID: selectedRowData?.CedarGateFormID
        ? selectedRowData?.CedarGateFormID
        : 0,
      client_Name: selectedRowData?.Client_Name,
      benefit_Point_ID: selectedRowData?.Benefit_Point_ID,
      Clientdba: selectedRowData?.Client_DBA,
      ZipCode: selectedRowData?.Client_Headquarters_Zip_Code,
      Industry: selectedRowData?.SIC_Sub_Industry,
      GroupType: selectedRowData?.Group_Type,
      hubSuperRegion: selectedRowData?.HUB_Super_Region,
      hubRegion: selectedRowData?.HUB_Region,
      hubLocalRegion: selectedRowData?.HUB_Local,
      NewHUBLocalName: selectedRowData?.New_HUB_Local_Name
        ? selectedRowData?.New_HUB_Local_Name
        : "",
      HUBContactName: selectedRowData?.HUB_Contact_Name,
      EligibilityVendor: selectedRowData?.Eligibility_Vendor,
      EligibilityHistoricalOngoingTimePeriod: ConvertFromateDate(
        selectedRowData?.Eligibility_Historical.split("-")
      ),
      EligibilityContactName: selectedRowData?.Eligibility_Contact_Name,
      EligibilityContactEMail: selectedRowData?.Eligibility_Contact_EMail,
      EligibilityContactPhone: selectedRowData?.Eligibility_Contact_Phone,
      MedicalVendor: selectedRowData?.Medical_Vendor,
      MedicalClaimsHistoricalOngoingTimePeriod: ConvertFromateDate(
        selectedRowData?.Medical_Claims_Historical.split("-")
      ),
      MedicalContactName: selectedRowData?.Medical_Contact_Name,
      MedicalContactEMail: selectedRowData?.Medical_Contact_EMail,
      MedicalContactPhone: selectedRowData?.Medical_Contact_Phone,
      MedicalNetwork1: selectedRowData?.Medical_Network_1
        ? selectedRowData?.Medical_Network_1
        : "",
      MedicalNetwork2: selectedRowData?.Medical_Network_2
        ? selectedRowData?.Medical_Network_2
        : "",
      MedicalNetwork3: selectedRowData?.Medical_Network_3
        ? selectedRowData?.Medical_Network_3
        : "",
      MedicalNetwork4: selectedRowData?.Medical_Network_4
        ? selectedRowData?.Medical_Network_4
        : "",
      MedicalNetwork5: selectedRowData?.Medical_Network_5
        ? selectedRowData?.Medical_Network_5
        : "",
      MedicalFundingType: selectedRowData?.Medical_Funding_Type,
      StopLossReinsurer: selectedRowData?.Stop_Loss_Reinsurer,
      StopLossReinsurerContractType:
        selectedRowData?.Stop_Loss_Reinsurer_Contract_Type,
      StopLossReinsurerRenewalDate:
        selectedRowData?.Stop_Loss_Reinsurer_Renewal.split("T")[0],
      ISLLimitPoolingPoint: selectedRowData?.ISL_Limit_Pooling_Point,
      AnalyticsFunding: selectedRowData?.Analytics_Funding,
      ClinicalConsulting: selectedRowData?.Clinical_Consulting,
      RxVendor: selectedRowData?.RX_Vendor,
      RxClaimsHistoricalOngoingTimePeriod: ConvertFromateDate(
        selectedRowData?.RX_Claims_Historical_Ongoing_Time_Period.split("-")
      ),
      RxContactName: selectedRowData?.Rx_Contact_Name,
      RxContactEMail: selectedRowData?.Rx_Contact_EMail,
      RxContactPhone: selectedRowData?.Rx_Contact_Phone,
      FormularyName1: selectedRowData?.Formulary_Name_1
        ? selectedRowData?.Formulary_Name_1
        : "",
      FormularyName2: selectedRowData?.Formulary_Name_2
        ? selectedRowData?.Formulary_Name_2
        : "",
      OtherVendor: selectedRowData?.Other_Vendor,
      OtherContactName: selectedRowData?.Other_Contact_Name,
      OtherContactEMail: selectedRowData?.Other_Contact_EMail,
      OtherContactPhone: selectedRowData?.Other_Contact_Phone,
      DentalVendor: selectedRowData?.Dental_Vendor,
      DentalContactName: selectedRowData?.Dental_Contact_Name,
      DentalContactEMail: selectedRowData?.Dental_Contact_EMail,
      DentalContactPhone: selectedRowData?.Dental_Contact_Phone,
      DentalFundingType: selectedRowData?.Dental_Funding_Type,
      VisionVendor: selectedRowData?.Vision_Vendor,
      VisionContactName: selectedRowData?.Vision_Contact_Name,
      VisionContactEMail: selectedRowData?.Vision_Contact_EMail,
      VisionContactPhone: selectedRowData?.Vision_Contact_Phone,
      VisionFundingType: selectedRowData?.Vision_Funding_Type,
      BenefitsRenewalDate:
        selectedRowData?.Benefits_Renewal_Date?.split("T")[0],
      EstEEHeadcount: selectedRowData?.Est_EE_Headcount,
      EstMbrHeadcount: selectedRowData?.Est_Mbr_Headcount,
      CompanySize: selectedRowData?.Company_Size,
      ArtemisExpDate: selectedRowData?.Artemis_Exp_Date?.split("T")[0],
      TransitionStatus: selectedRowData?.Transition_Status,
      ImplementationStatus: selectedRowData?.Implementation_Status,
      TermedArtemisNoPreviousSystem: selectedRowData?.Termed_Artemis,
      EOMDeadlineImpl: selectedRowData?.EOM_Deadline,
      CGTNotified: selectedRowData?.CGT_Notified,
      CGTDateCompleted: selectedRowData?.CGT_Date_Completed?.split("T")[0],
      CGTNoticeEligibility: selectedRowData?.CGT_Notice_Eligibility,
      CGTNoticeMedical: selectedRowData?.CGT_Notice_Medical,
      CGTNoticeRx: selectedRowData?.CGT_Notice_Rx,
      CGTNoticeOther: selectedRowData?.CGT_Notice_Other,
      CGTNoticeDental: selectedRowData?.CGT_Notice_Dental,
      CGTNoticeVision: selectedRowData?.CGT_Notice_Vision,
      WrapNetworkSubContractedNetwork: selectedRowData?.Wrap_Network,
      DomesticIncentive: selectedRowData?.Domestic_Incentive,
      ASLLimitPoolingPoint: selectedRowData?.ASL_Limit_Pooling_Point,
      AnalyticsFundingContactName:
        selectedRowData?.Analytics_Funding_Contact_Name,
      AnalyticsFundingContactEMailAddress:
        selectedRowData?.Analytics_Funding_Contact_Email,
      AnalyticsFundingContactPhoneNumber:
        selectedRowData?.Analytics_Funding_Contact_Phone,
      SecondndEligibilityHistoricalOngoingTimePeriod: ConvertFromateDate(
        selectedRowData?.Second_Eligibility_Historical?.split("-")
      ),
      OtherVendor2: selectedRowData?.Other_Vendor2,
      OtherContactName2: selectedRowData?.Other_Contact_Name2,
      OtherContactEmail2: selectedRowData?.Other_Contact_Email2,
      OtherContactPhone2: selectedRowData?.Other_Contact_Phone2,
      SLCarrierFundingNotice: selectedRowData?.SL_Carrier_Funding_Notice,
      ClientEmailReceived: selectedRowData?.Client_Email_Received,
      NDAReceived: selectedRowData?.NDA_Received,
      LOIReceived: selectedRowData?.LOI_Received,
      GoLiveDate: selectedRowData?.Go_Live_Date?.split("T")[0],
      InnovuTermDate: selectedRowData?.Innovu_Term_Date?.split("T")[0],
      Notes: selectedRowData?.Notes,
    },
  });

  useEffect(() => {
    if (Object.keys(errors).length) {
      const accessorKey = document.getElementsByName(Object.keys(errors)[0])[0];
      if (accessorKey) {
        accessorKey.focus();
      }
    }
  }, [isFocus]);
  const formatDate = (dateString) => {
    if (!dateString) {
      return ''; // Return empty string if dateString is falsy
    }
  
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
  
    return `${month}/${day}/${year}`;
  };

  const columns = useMemo(
    () => [
      {
        header: "Benefit Point",
        accessorKey: "Benefit_Point_ID",
        enableColumnFilter:false

      },
      { header: "Client Name", accessorKey: "Client_Name",  enableColumnFilter:false },
      { header: "Client DBA", accessorKey: "Client_DBA",  enableColumnFilter:false },
      // { header: "Created Date", accessorKey: "CreatedDate", type: "date" },
      {
        header: "Client Headquarters Zip Code",
        accessorKey: "Client_Headquarters_Zip_Code",
        enableColumnFilter:false
      },
      { header: "SIC Sub Industry", accessorKey: "SIC_Sub_Industry",  enableColumnFilter:false },
      {
        header: "Group Type",
        accessorKey: "Group_Type",
        filterVariant: "multi-select",
        enableColumnFilter:true
      },
      {
        header: "HUB Super Region",
        accessorKey: "HUB_Super_Region",
        filterVariant: "multi-select",
        enableColumnFilter:true
      },
      {
        header: "HUB Region",
        accessorKey: "HUB_Region",
        filterVariant: "multi-select",
        enableColumnFilter:true
      },
      { header: "HUB Local", accessorKey: "HUB_Local", enableColumnFilter:false  },
      {
        header: "New HUB Local Name",
        accessorKey: "New_HUB_Local_Name",
        enableColumnFilter:false
      },
      { header: "HUB Contact Name", accessorKey: "HUB_Contact_Name",  enableColumnFilter:false },
      {
        header: "Eligibility Vendor",
        accessorKey: "Eligibility_Vendor",
        filterVariant: "multi-select",
        enableColumnFilter:true
      },
      {
        header: "Eligibility Historical (Time Period)",
        accessorKey: "Eligibility_Historical",
        enableColumnFilter:false
      },
      {
        header: "Eligibility Contact Name",
        accessorKey: "Eligibility_Contact_Name",
        enableColumnFilter:false
      },
      {
        header: "Eligibility Contact E-mail",
        accessorKey: "Eligibility_Contact_EMail",
        enableColumnFilter:false
      },
      {
        header: "Eligibility Contact Phone",
        accessorKey: "Eligibility_Contact_Phone",
        enableColumnFilter:false
      },
      {
        header: "Medical Vendor",
        accessorKey: "Medical_Vendor",
        filterVariant: "multi-select",
        enableColumnFilter:true
      },
      {
        header: "Medical Claims Historical (Time Period)",
        accessorKey: "Medical_Claims_Historical",
        enableColumnFilter:false
      },
      {
        header: "Medical Contact Name",
        accessorKey: "Medical_Contact_Name",
        enableColumnFilter:false
      },
      {
        header: "Medical Contact E-mail",
        accessorKey: "Medical_Contact_EMail",
        enableColumnFilter:false
      },
      {
        header: "Medical Contact Phone",
        accessorKey: "Medical_Contact_Phone",
        enableColumnFilter:false
      },
      {
        header: "Medical Network 1",
        accessorKey: "Medical_Network_1",
        enableColumnFilter:false
      },
      {
        header: "Medical Network 2",
        accessorKey: "Medical_Network_2",
        enableColumnFilter:false
      },
      {
        header: "Medical Network 3",
        accessorKey: "Medical_Network_3",
        enableColumnFilter:false
      },
      {
        header: "Medical Network 4",
        accessorKey: "Medical_Network_4",
        enableColumnFilter:false
      },
      {
        header: "Medical Network 5",
        accessorKey: "Medical_Network_5",
        enableColumnFilter:false
      },
      {
        header: "Medical Funding Type",
        accessorKey: "Medical_Funding_Type",
        enableColumnFilter:false
      },
      {
        header: "Stop Loss Reinsurer",
        accessorKey: "Stop_Loss_Reinsurer",
        enableColumnFilter:false
      },
      {
        header: "Stop Loss Reinsurer Contract Type",
        accessorKey: "Stop_Loss_Reinsurer_Contract_Type",
        enableColumnFilter:false
      },
      {
        header: "Stop Loss Reinsurer Renewal",
        accessorKey: "Stop_Loss_Reinsurer_Renewal",
        type: "date",
        enableColumnFilter:false
      },
      {
        header: "ISL Limit Pooling Point",
        accessorKey: "ISL_Limit_Pooling_Point",
        enableColumnFilter:false
        //type: "numeric",
      },
      {
        header: "Analytics Funding",
        accessorKey: "Analytics_Funding",
        filterVariant: "multi-select",
        enableColumnFilter:true
      },
      {
        header: "Clinical Consulting",
        accessorKey: "Clinical_Consulting",
        enableColumnFilter:false
      },
      {
        header: "RX Vendor",
        accessorKey: "RX_Vendor",
        filterVariant: "multi-select",
        enableColumnFilter:true
      },
      {
        header: "RX Claims Historical (Time Period)",
        accessorKey: "RX_Claims_Historical_Ongoing_Time_Period",
        enableColumnFilter:false
      },
      { header: "Rx Contact Name", accessorKey: "Rx_Contact_Name", enableColumnFilter:false  },
      { header: "Rx Contact E-mail", accessorKey: "Rx_Contact_EMail",  enableColumnFilter:false },
      { header: "Rx Contact Phone", accessorKey: "Rx_Contact_Phone",  enableColumnFilter:false },
      { header: "Formulary Name 1", accessorKey: "Formulary_Name_1",  enableColumnFilter:false },
      { header: "Formulary Name 2", accessorKey: "Formulary_Name_2",  enableColumnFilter:false },
      {
        header: "Other Vendor",
        accessorKey: "Other_Vendor",
        filterVariant: "multi-select",
        enableColumnFilter:true
      },
      {
        header: "Other Contact Name",
        accessorKey: "Other_Contact_Name",
        enableColumnFilter:false
      },
      {
        header: "Other Contact E-mail",
        accessorKey: "Other_Contact_EMail",
        enableColumnFilter:false
      },
      {
        header: "Other Contact Phone",
        accessorKey: "Other_Contact_Phone",
        enableColumnFilter:false
      },
      {
        header: "Dental Vendor",
        accessorKey: "Dental_Vendor",
        filterVariant: "multi-select",
        enableColumnFilter:true
      },
      {
        header: "Dental Contact Name",
        accessorKey: "Dental_Contact_Name",
        enableColumnFilter:false
      },
      {
        header: "Dental Contact E-mail",
        accessorKey: "Dental_Contact_EMail",
        enableColumnFilter:false
      },
      {
        header: "Dental Contact Phone",
        accessorKey: "Dental_Contact_Phone",
         enableColumnFilter:false
      },
      {
        header: "Dental Funding Type",
        accessorKey: "Dental_Funding_Type",
         enableColumnFilter:false
      },
      {
        header: "Vision Vendor",
        accessorKey: "Vision_Vendor",
        filterVariant: "multi-select",
        enableColumnFilter:true
      },
      {
        header: "Vision Contact Name",
        accessorKey: "Vision_Contact_Name",
         enableColumnFilter:false
      },
      {
        header: "Vision Contact E-mail",
        accessorKey: "Vision_Contact_EMail",
         enableColumnFilter:false
      },
      {
        header: "Vision Contact Phone",
        accessorKey: "Vision_Contact_Phone",
         enableColumnFilter:false
      },
      {
        header: "Vision Funding Type",
        accessorKey: "Vision_Funding_Type",
         enableColumnFilter:false
      },
      {
        header: "Benefits Renewal Date",
        accessorKey: "Benefits_Renewal_Date",
        type: "date",
        enableColumnFilter:false,
        accessorFn: (row) => formatDate(row.Benefits_Renewal_Date)
      },
      { header: "Est. EE Headcount", accessorKey: "Est_EE_Headcount", enableColumnFilter:false },
      { header: "Est. Mbr Headcount", accessorKey: "Est_Mbr_Headcount", enableColumnFilter:false },
      { header: "Company Size", accessorKey: "Company_Size" , enableColumnFilter:false},
      {
        header: "Artemis Exp. Date",
        accessorKey: "Artemis_Exp_Date",
        type: "date",
        accessorFn: (row) => formatDate(row.Artemis_Exp_Date),
        enableColumnFilter:false
      },
      { header: "Transition Status", accessorKey: "Transition_Status", enableColumnFilter:false },
      {
        header: "Implementation Status",
        accessorKey: "Implementation_Status",
        filterVariant: "multi-select",
        enableColumnFilter:true
      },
      { header: "Termed Artemis / No Previous System", accessorKey: "Termed_Artemis", enableColumnFilter:false },
      {
        header: "EOM Deadline / Impl.",
        accessorKey: "EOM_Deadline",
        filterVariant: "multi-select",
        enableColumnFilter:true
      },
      { header: "CGT Notified?", accessorKey: "CGT_Notified", enableColumnFilter:false },
      {
        header: "CGT Date (Completed)",
        accessorKey: "CGT_Date_Completed",
        type: "date",
        enableColumnFilter:false,
        accessorFn: (row) => formatDate(row.CGT_Date_Completed)
      },
      { header: "CGT Notice Eligibility", accessorKey: "CGT_Notice_Eligibility", enableColumnFilter:false },
      { header: "CGT Notice Medical", accessorKey: "CGT_Notice_Medical", enableColumnFilter:false },
      { header: "CGT Notice Rx", accessorKey: "CGT_Notice_Rx", enableColumnFilter:false },
      { header: "CGT Notice Other", accessorKey: "CGT_Notice_Other", enableColumnFilter:false },
      { header: "CGT Notice Dental", accessorKey: "CGT_Notice_Dental", enableColumnFilter:false },
      { header: "CGT Notice Vision", accessorKey: "CGT_Notice_Vision", enableColumnFilter:false },
      { header: "Wrap Network (Sub Contracted Network)", accessorKey: "Wrap_Network", enableColumnFilter:false },
      { header: "Domestic Incentive?", accessorKey: "Domestic_Incentive",enableColumnFilter:false },
      { header: "ASL Limit / Pooling Point", accessorKey: "ASL_Limit_Pooling_Point", enableColumnFilter:false },
      {
        header: "Analytics Funding Contact Name",
        accessorKey: "Analytics_Funding_Contact_Name",
        enableColumnFilter:false
      },
      {
        header: "Analytics Funding Contact E-Mail Address",
        accessorKey: "Analytics_Funding_Contact_Email",
        enableColumnFilter:false
      },
      {
        header: "Analytics Funding Contact Phone Number",
        accessorKey: "Analytics_Funding_Contact_Phone",
        enableColumnFilter:false
      },
      {
        header: "2nd Eligibility Historical/Ongoing Time Period",
        accessorKey: "Second_Eligibility_Historical",
        enableColumnFilter:false
      },
      { header: "Other Vendor 2", accessorKey: "Other_Vendor2" , enableColumnFilter:false},
      { header: "Other Contact Name 2", accessorKey: "Other_Contact_Name2", enableColumnFilter:false },
      { header: "Other Contact Email 2", accessorKey: "Other_Contact_Email2", enableColumnFilter:false },
      { header: "Other Contact Phone 2", accessorKey: "Other_Contact_Phone2" , enableColumnFilter:false},
      {
        header: "SL / Carrier Funding Notice",
        accessorKey: "SL_Carrier_Funding_Notice",
        enableColumnFilter:false
      },
      { header: "Client Email Received", accessorKey: "Client_Email_Received", enableColumnFilter:false },
      { header: "NDA Received", accessorKey: "NDA_Received", enableColumnFilter:false },
      { header: "LOI Received", accessorKey: "LOI_Received" , enableColumnFilter:false},
      {
        header: "Go Live Date",
        accessorKey: "Go_Live_Date",
        type: "date",
        accessorFn: (row) => formatDate(row.Go_Live_Date),
        enableColumnFilter:false
      },
      {
        header: "Innovu Term Date",
        accessorKey: "Innovu_Term_Date",
        type: "date",
        accessorFn: (row) => formatDate(row.Innovu_Term_Date),
        enableColumnFilter:false
      },
      { header: "Notes", accessorKey: "Notes", enableColumnFilter:false },
      {
        accessorKey: "Date_Ticket_Submitted_to_CGT",
        header: "Implementation form Submitted date",
        enableColumnFilter:true,
        filterVariant: "multi-select",
        accessorFn: (row) => formatDate(row.Date_Ticket_Submitted_to_CGT)
      }      
      // {
      //   accessorFn: (Row) => new Date(Row.Date_Ticket_Submitted_to_CGT),
      //   id: "Date_Ticket_Submitted_to_CGT",
      //   header: "Implementation form Submitted date",
      //   filterVariant: "date",
      //   filterFn: 'customFilterFn',
      //   enableColumnFilter:true,
      //   Cell: ({ cell }) => {
      //     const cellValue = cell?.getValue();
      //     return cellValue ? new Date(cellValue).toLocaleDateString() : '';
      //   }
      // }      
    ],
    [],
  );

  useEffect(() => {
    if (showModal === false) {
      resetForm();
      setSelectedRowData(null);
      setRegionData(false);
    }
    if (isGetData) {
      GetData();
    }
    setIsGetData(false);
    if (showModal && witchAction === "update") {
      setRegionData(true);
    }
  }, [showModal]);

  useEffect(() => {
    GetData();
  }, []);

  const GetData = () => {
    setIsLoading(true);
    GetCedarGeteForm()
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          setData(res.data.data);
          setIsLoading(false);
        }
      })
      .catch((err) => setIsLoading(false));
  };

  const fileName =
    location.pathname.split("/")[location.pathname.split("/").length - 1] +
    "_" +
    (parseInt(new Date().getMonth()) + 1) +
    "_" +
    new Date().getDate() +
    "_" +
    new Date().getFullYear() +
    "_" +
    new Date().getHours() +
    "_" +
    new Date().getMinutes() +
    "_" +
    new Date().getSeconds();

  const csvData = [
    columns.map((item) => item.header),
    ...data.map((item) => [
      item.Benefit_Point_ID,
      item.Client_Name,
      item.Client_DBA,
      item.Client_Headquarters_Zip_Code,
      item.SIC_Sub_Industry,
      item.Group_Type,
      item.HUB_Super_Region,
      item.HUB_Region,
      item.HUB_Local,
      item.New_HUB_Local_Name,
      item.HUB_Contact_Name,
      item.Eligibility_Vendor,
      item.Eligibility_Historical,
      item.Eligibility_Contact_Name,
      item.Eligibility_Contact_EMail,
      item.Eligibility_Contact_Phone,
      item.Medical_Vendor,
      item.Medical_Claims_Historical,
      item.Medical_Contact_Name,
      item.Medical_Contact_EMail,
      item.Medical_Contact_Phone,
      item.Medical_Network_1,
      item.Medical_Network_2,
      item.Medical_Network_3,
      item.Medical_Network_4,
      item.Medical_Network_5,
      item.Medical_Funding_Type,
      item.Stop_Loss_Reinsurer,
      item.Stop_Loss_Reinsurer_Contract_Type,
      formatDate(item.Stop_Loss_Reinsurer_Renewal),
      item.ISL_Limit_Pooling_Point,
      item.Analytics_Funding,
      item.Clinical_Consulting,
      item.RX_Vendor,
      item.RX_Claims_Historical_Ongoing_Time_Period,
      item.Rx_Contact_Name,
      item.Rx_Contact_EMail,
      item.Rx_Contact_Phone,
      item.Formulary_Name_1,
      item.Formulary_Name_2,
      item.Other_Vendor,
      item.Other_Contact_Name,
      item.Other_Contact_EMail,
      item.Other_Contact_Phone,
      item.Dental_Vendor,
      item.Dental_Contact_Name,
      item.Dental_Contact_EMail,
      item.Dental_Contact_Phone,
      item.Dental_Funding_Type,
      item.Vision_Vendor,
      item.Vision_Contact_Name,
      item.Vision_Contact_EMail,
      item.Vision_Contact_Phone,
      item.Vision_Funding_Type,
      formatDate(item.Benefits_Renewal_Date),
      item.Est_EE_Headcount,
      item.Est_Mbr_Headcount,
      item.Company_Size,
      formatDate(item.Artemis_Exp_Date),
      item.Transition_Status,
      item.Implementation_Status,
      item.Termed_Artemis,
      item.EOM_Deadline,
      item.CGT_Notified,
      formatDate(item.CGT_Date_Completed),
      item.CGT_Notice_Eligibility,
      item.CGT_Notice_Medical,
      item.CGT_Notice_Rx,
      item.CGT_Notice_Other,
      item.CGT_Notice_Dental,
      item.CGT_Notice_Vision,
      item.Wrap_Network,
      item.Domestic_Incentive,
      item.ASL_Limit_Pooling_Point,
      item.Analytics_Funding_Contact_Name,
      item.Analytics_Funding_Contact_Email,
      item.Analytics_Funding_Contact_Phone,
      item.Second_Eligibility_Historical,
      item.Other_Vendor2,
      item.Other_Contact_Name2,
      item.Other_Contact_Email2,
      item.Other_Contact_Phone2,
      item.SL_Carrier_Funding_Notice,
      item.Client_Email_Received,
      item.NDA_Received,
      item.LOI_Received,
      formatDate(item.Go_Live_Date),
      formatDate(item.Innovu_Term_Date),
      item.Notes,
      formatDate(item.Date_Ticket_Submitted_to_CGT)
    ]),
  ];

  

  return (
    <>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-header-vcenter"
        centered={witchAction !== "delete"}
        size={witchAction === "delete" ? "md" : "xl"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-header-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            New Group Implementation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={witchAction !== "delete" ? "p-0 pb-3" : ""}>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteCedarGeteForm(selectedRowData?.CedarGateFormID).then(
                  (res) => {
                    toastFile("delete");
                    setIsGetData(true);
                    setShowModal(false);
                  }
                );
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <div className="d-flex col-12 justify-content-between flex-wrap px-3">
              <ReactTooltip
                className="w-25 border-2 border-info p-2"
                border
                backgroundColor="white"
                textColor="black"
              />
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 mt-2 mb-3">
                <p style={Fontstyling.heading}>Welcome to Infused Analytics!</p>
                <p className="lh-2 mt-1" style={Fontstyling.primaryparagraph}>
                  This intake request form is required for any new client
                  implementation requests in order to ensure proper set up
                  within Cedar Gate and the connectivity with the Infused
                  Analytics platform.
                </p>
                <p style={Fontstyling.label}>
                  Within forty-eight (48) business hours, a member of the team
                  will reach out to you to confirm the details of your
                  submission and begin the carrier outreach process for
                  implementation.
                </p>
                <p style={Fontstyling.label}>
                  Please Note: The estimated implementation timeline is
                  approximately 3 to 4 months once all legal documents have been
                  executed. You may be asked to participate in the
                  implementation process by obtaining signatures for such
                  agreements from your client. In some instances, a global NDA
                  may already be in place allowing for a simple signature. For
                  additional questions, please contact a member of the team.
                </p>
                <p style={Fontstyling.label}>
                  Thank you and we look forward to assisting you with your new
                  implementation!
                </p>
                <p style={Fontstyling.label}>Sincerely,</p>
                <p style={{ ...Fontstyling.label, lineHeight: 0 }}>
                  The Clinical Informatics Team.
                </p>
              </div>
              <Form
                onSubmit={handleSubmit}
                className="col-12 col-sm-12 col-md-12 col-lg-5 p-1"
                style={{ height: "500px", overflowY: "scroll" }}
              >
                {witchAction === "delete" ? (
                  <div className="text-wrap">
                    Are you sure that you want to delete the record?
                  </div>
                ) : (
                  <>
                    <Row className="gap-3 d-block">
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="mb-1"
                            style={Fontstyling.label}
                          >
                            Benefit Point ID
                            <Required />
                          </Form.Label>
                          <Form.Control
                            className="rounded-0 py-1 mb-2"
                            style={Fontstyling.label}
                            type="text"
                            placeholder="Benefit Point ID"
                            name="benefit_Point_ID"
                            value={values.benefit_Point_ID}
                            disabled={false}
                            maxLength={256}
                            onChange={handleChange}
                            isInvalid={
                              touched.benefit_Point_ID &&
                              errors.benefit_Point_ID
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.benefit_Point_ID}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="mb-1"
                            style={Fontstyling.label}
                          >
                            Client Name
                            <Required />
                          </Form.Label>
                          <Form.Control
                            className="rounded-0 py-1 mb-2"
                            style={Fontstyling.label}
                            type="text"
                            placeholder="Client Name"
                            name="client_Name"
                            value={values.client_Name}
                            disabled={false}
                            maxLength={512}
                            onChange={handleChange}
                            isInvalid={
                              touched.client_Name && errors.client_Name
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.client_Name}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Client DBA
                            <Required />
                          </Form.Label>
                          <Form.Control
                            name="Clientdba"
                            maxLength={512}
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.Clientdba}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.Clientdba && errors.Clientdba}
                            type="text"
                            placeholder="Client DBA"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.Clientdba}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="gap-3 d-block">
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Client Headquarters Zip Code
                            <Required />
                          </Form.Label>
                          <Form.Control
                            name="ZipCode"
                            maxLength={10}
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.ZipCode}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.ZipCode && errors.ZipCode}
                            type="text"
                            placeholder="Client Headquarters Zip Code"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.ZipCode}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            SIC Sub Industry
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="Industry"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.Industry}
                            isInvalid={touched.Industry && errors.Industry}
                          >
                            <option value={""}>Select SIC Sub Industry</option>
                            {DropdownData?.industryData.map((item, index) => (
                              <option key={index} value={item.IndustryName}>
                                {item.IndustryName}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.Industry}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Group Type
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="GroupType"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.GroupType}
                            isInvalid={touched.GroupType && errors.GroupType}
                          >
                            <option value={""}>Select Group Type</option>
                            {[
                              "Artemis",
                              "New Implementation",
                              "Other System",
                            ].map((item, index) => (
                              <option
                                // className={`${
                                //   index === 0
                                //     ? "bg-danger"
                                //     : index === 1
                                //     ? "bg-warning"
                                //     : "bg-success"
                                // }`}
                                key={index}
                                value={item}
                              >
                                {item}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.GroupType}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="gap-3 d-block">
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            HUB Super Region
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="hubSuperRegion"
                            onChange={(e) => {
                              handleChange(e);
                              setRegionDropdownData((prev) => ({
                                ...prev,
                                region: [
                                  ...new Set(
                                    prev.allRegion
                                      .filter(
                                        (el) =>
                                          el.hubSuperRegion === e.target.value
                                      )
                                      .map((el2) => el2.hubRegion)
                                  ),
                                ].sort(),
                                localRegion: [],
                              }));
                            }}
                            onBlur={handleBlur}
                            value={values.hubSuperRegion}
                            isInvalid={
                              touched.hubSuperRegion && errors.hubSuperRegion
                            }
                          >
                            <option value="">Select HUB Super Region</option>
                            {regionDropdownData.superRegion.map(
                              (item, index) => (
                                <option value={item} key={index}>
                                  {item}
                                </option>
                              )
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.hubSuperRegion}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            HUB Region
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="hubRegion"
                            onChange={(e) => {
                              handleChange(e);
                              setRegionDropdownData((prev) => ({
                                ...prev,
                                localRegion: [
                                  ...new Set(
                                    prev.allRegion.filter(
                                      (el) => el.hubRegion === e.target.value
                                    )
                                  ),
                                ].sort(),
                              }));
                            }}
                            onBlur={handleBlur}
                            value={values.hubRegion}
                            isInvalid={touched.hubRegion && errors.hubRegion}
                          >
                            <option value="">Select HUB Region</option>
                            {regionDropdownData.region.map((item, index) => (
                              <option value={item} key={index}>
                                {item}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.hubRegion}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            HUB Local
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="hubLocalRegion"
                            onChange={(e) => {
                              handleChange(e);
                              //   setRegionDropdownData((prev) => ({
                              //     ...prev,
                              //     hubLocalRegion: [
                              //       ...new Set(
                              //         prev.allRegion.filter(
                              //           (el) => el.hubLocalRegion === e.target.value
                              //         )
                              //       ),
                              //     ].sort(),
                              //   }));
                            }}
                            onBlur={handleBlur}
                            value={values.hubLocalRegion}
                            isInvalid={
                              touched.hubLocalRegion && errors.hubLocalRegion
                            }
                          >
                            <option value="">Select HUB Local</option>
                            {regionDropdownData.localRegion.map(
                              (item, index) => (
                                <option value={item.hubLocal} key={index}>
                                  {item.hubLocal}
                                </option>
                              )
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.hubLocalRegion}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            New HUB Local Name
                          </Form.Label>
                          <img
                            data-tip="Only use if you have selected ZZZ-NOT LISTED"
                            src={require("../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />

                          <Form.Control
                            name="NewHUBLocalName"
                            maxLength={512}
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.NewHUBLocalName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.NewHUBLocalName && errors.NewHUBLocalName
                            }
                            type="text"
                            placeholder="New HUB Local Name"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.NewHUBLocalName}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            HUB Contact Name
                            <Required />
                          </Form.Label>
                          <Form.Control
                            name="HUBContactName"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.HUBContactName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.HUBContactName && errors.HUBContactName
                            }
                            type="text"
                            placeholder="HUB Contact Name"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.HUBContactName}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="gap-3 d-block">
                    <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Eligibility Vendor
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="EligibilityVendor"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.EligibilityVendor}
                            isInvalid={
                              touched.EligibilityVendor &&
                              errors.EligibilityVendor
                            }
                          >
                            <option value={""}>Select Vendor</option>
                            {DropdownData?.VendorList.sort().map(
                              (item, index) => (
                                <option
                                  key={index}
                                  value={item}
                                >
                                  {item}
                                </option>
                              )
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.EligibilityVendor}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      {[
                        
                        {
                          label: "Eligibility Historical/Ongoing Time Period",
                          value: "EligibilityHistoricalOngoingTimePeriod",
                          isRequired: true,
                        },
                        {
                          label: "Eligibility Contact Name",
                          value: "EligibilityContactName",
                          isRequired: true,
                        },
                        {
                          label: "Eligibility Contact E-mail",
                          value: "EligibilityContactEMail",
                          isRequired: true,
                        },
                        {
                          label: "Eligibility Contact Phone",
                          value: "EligibilityContactPhone",
                          isRequired: true,
                        },
                      ].map(({ label, value }) => {
                        if (
                          value === "EligibilityHistoricalOngoingTimePeriod"
                        ) {
                          return (
                            <Col>
                              <Form.Group className="mb-2">
                                <Form.Label
                                  className="text-nowrap mb-1"
                                  style={Fontstyling.label}
                                >
                                  {label}
                                  <Required />
                                  <img
                                    data-tip="Please list the dates of eligibility information you're wanting/expecting to receive from the eligibility carrier (i.e. 1/1/2020 - current, 1/1/2020 - 12/31/2022, etc.)"
                                    src={require("../../assets/icon/Question_mark_back.png")}
                                    style={{ height: 15, marginLeft: 3 }}
                                  />
                                </Form.Label>
                                <DateRangePicker
                                  placement="auto"
                                  showOneCalendar
                                  placeholder="mm/dd/yyyy ~ mm/dd/yyyy"
                                  name="EligibilityHistoricalOngoingTimePeriod"
                                  style={{
                                    border:
                                      errors.EligibilityHistoricalOngoingTimePeriod &&
                                      touched.EligibilityHistoricalOngoingTimePeriod
                                        ? "1px solid #dc3545"
                                        : "1px solid #dee2e6",
                                    zIndex: 999,
                                  }}
                                  editable={false}
                                  value={values[value]}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "EligibilityHistoricalOngoingTimePeriod",
                                      e
                                    );
                                  }}
                                  onBlur={handleBlur}
                                  format="MM-dd-yyyy"
                                />
                                {errors.EligibilityHistoricalOngoingTimePeriod &&
                                  touched.EligibilityHistoricalOngoingTimePeriod && (
                                    <Form.Label
                                      className="text-nowrap fw-bold"
                                      style={Fontstyling.errorlabel}
                                    >
                                      {
                                        errors.EligibilityHistoricalOngoingTimePeriod
                                      }
                                    </Form.Label>
                                  )}
                              </Form.Group>
                            </Col>
                          );
                        } else {
                          return (
                            <Col>
                              <Form.Group className="text-nowrap mb-2">
                                <Form.Label
                                  className="text-nowrap mb-1"
                                  style={Fontstyling.label}
                                >
                                  {label}
                                  <Required />
                                </Form.Label>
                                <Form.Control
                                  name={value}
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values[value]}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={touched[value] && errors[value]}
                                  type="text"
                                  placeholder={label}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors[value]}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          );
                        }
                      })}
                    </Row>
                    <Row className="gap-3 d-block">
                    <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Medical Vendor
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="MedicalVendor"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.MedicalVendor}
                            isInvalid={
                              touched.MedicalVendor &&
                              errors.MedicalVendor
                            }
                          >
                            <option value={""}>Select Vendor</option>
                            {DropdownData?.VendorList.sort().map(
                              (item, index) => (
                                <option
                                  key={index}
                                  value={item}
                                >
                                  {item}
                                </option>
                              )
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.MedicalVendor}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      {[
                        
                        {
                          label:
                            "Medical Claims Historical/Ongoing Time Period",
                          value: "MedicalClaimsHistoricalOngoingTimePeriod",
                          isRequired: true,
                        },
                        {
                          label: "Medical Contact Name",
                          value: "MedicalContactName",
                          isRequired: true,
                        },
                        {
                          label: "Medical Contact E-mail",
                          value: "MedicalContactEMail",
                          isRequired: true,
                        },
                        {
                          label: "Medical Contact Phone",
                          value: "MedicalContactPhone",
                          isRequired: true,
                        },
                      ].map(({ label, value }) => {
                        if (
                          value === "MedicalClaimsHistoricalOngoingTimePeriod"
                        ) {
                          return (
                            <Col>
                              <Form.Group className="mb-2">
                                <Form.Label
                                  className="text-nowrap mb-1"
                                  style={Fontstyling.label}
                                >
                                  {label}
                                  <Required />
                                  <img
                                    data-tip="Please list the dates of claims information you're wanting/expecting to receive from the medical carrier (i.e. 1/1/2020 - current, 1/1/2020 - 12/31/2022, etc.)"
                                    src={require("../../assets/icon/Question_mark_back.png")}
                                    style={{ height: 15, marginLeft: 3 }}
                                  />
                                </Form.Label>
                                <DateRangePicker
                                  showOneCalendar
                                  placement="auto"
                                  placeholder="mm/dd/yyyy ~ mm/dd/yyyy"
                                  name="MedicalClaimsHistoricalOngoingTimePeriod"
                                  style={{
                                    border:
                                      errors.MedicalClaimsHistoricalOngoingTimePeriod &&
                                      touched.MedicalClaimsHistoricalOngoingTimePeriod
                                        ? "1px solid #dc3545"
                                        : "1px solid #dee2e6",
                                  }}
                                  editable={false}
                                  value={values[value]}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "MedicalClaimsHistoricalOngoingTimePeriod",
                                      e
                                    );
                                  }}
                                  onBlur={handleBlur}
                                  format="MM-dd-yyyy"
                                />
                                {errors.MedicalClaimsHistoricalOngoingTimePeriod &&
                                  touched.MedicalClaimsHistoricalOngoingTimePeriod && (
                                    <Form.Label
                                      className="text-nowrap fw-bold"
                                      style={Fontstyling.errorlabel}
                                    >
                                      {
                                        errors.MedicalClaimsHistoricalOngoingTimePeriod
                                      }
                                    </Form.Label>
                                  )}
                              </Form.Group>
                            </Col>
                          );
                        } else {
                          return (
                            <Col>
                              <Form.Group className="text-nowrap mb-2">
                                <Form.Label
                                  className="text-nowrap mb-1"
                                  style={Fontstyling.label}
                                >
                                  {label}
                                  <Required />
                                </Form.Label>
                                <Form.Control
                                  name={value}
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values[value]}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={touched[value] && errors[value]}
                                  type="text"
                                  placeholder={label}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors[value]}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          );
                        }
                      })}
                    </Row>
                    <Row className="gap-3 d-block">
                      {[
                        {
                          label: "Medical Network 1",
                          value: "MedicalNetwork1",
                          isRequired: false,
                        },
                        {
                          label: "Medical Network 2",
                          value: "MedicalNetwork2",
                          isRequired: false,
                        },
                        {
                          label: "Medical Network 3",
                          value: "MedicalNetwork3",
                          isRequired: false,
                        },
                        {
                          label: "Medical Network 4",
                          value: "MedicalNetwork4",
                          isRequired: false,
                        },
                        {
                          label: "Medical Network 5",
                          value: "MedicalNetwork5",
                          isRequired: false,
                        },
                      ].map(({ label, value, isRequired }) => (
                        <Col>
                          <Form.Group className="text-nowrap mb-2">
                            <Form.Label
                              className="text-nowrap mb-1"
                              style={Fontstyling.label}
                            >
                              {label}
                              {isRequired && <Required />}
                              <img
                                data-tip="(Optional) - If Selected, Please confirm the Plan Type,
                         followed by, Medical Network Name (i.e. PPO, ANTHEM PRUDENT BUYER PPO)"
                                src={require("../../assets/icon/Question_mark_back.png")}
                                style={{ height: 15, marginLeft: 3 }}
                              />
                            </Form.Label>
                            <Form.Control
                              name={value}
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values[value]}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched[value] && errors[value]}
                              type="text"
                              placeholder={label}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors[value]}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      ))}
                    </Row>
                    <Row className="gap-3 d-block">
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Medical Funding Type
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="MedicalFundingType"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.MedicalFundingType}
                            isInvalid={
                              touched.MedicalFundingType &&
                              errors.MedicalFundingType
                            }
                          >
                            <option value={""}>
                              Select Medical Funding Type
                            </option>
                            {DropdownData?.MedicalFundingType.map(
                              (item, index) => (
                                <option
                                  value={item.MedicalFundingName}
                                  key={index}
                                >
                                  {item.MedicalFundingName}
                                </option>
                              )
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.MedicalFundingType}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="mb-1"
                            style={Fontstyling.label}
                          >
                            Stop Loss / Reinsurer
                            <Required />
                          </Form.Label>
                          <Form.Control
                            className="rounded-0 py-1 mb-2"
                            style={Fontstyling.label}
                            type="text"
                            placeholder="Stop Loss / Reinsurer"
                            name="StopLossReinsurer"
                            value={values.StopLossReinsurer}
                            onChange={handleChange}
                            isInvalid={
                              touched.StopLossReinsurer &&
                              errors.StopLossReinsurer
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.StopLossReinsurer}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="mb-1"
                            style={Fontstyling.label}
                          >
                            Stop Loss / Reinsurer Contract Type
                            <Required />
                            <img
                              data-tip="i.e., 12/12, 12/15, 24/12, 18/12, etc."
                              src={require("../../assets/icon/Question_mark_back.png")}
                              style={{ height: 15, marginLeft: 3 }}
                            />
                          </Form.Label>
                          <Form.Control
                            className="rounded-0 py-1 mb-2"
                            style={Fontstyling.label}
                            type="text"
                            placeholder="Stop Loss / Reinsurer Contract Type"
                            name="StopLossReinsurerContractType"
                            value={values.StopLossReinsurerContractType}
                            onChange={handleChange}
                            isInvalid={
                              touched.StopLossReinsurerContractType &&
                              errors.StopLossReinsurerContractType
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.StopLossReinsurerContractType}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="mb-1"
                            style={Fontstyling.label}
                          >
                            Stop Loss / Reinsurer Renewal Date
                            <Required />
                          </Form.Label>
                          <Form.Control
                            className="rounded-0 py-1 mb-2"
                            style={Fontstyling.label}
                            type="date"
                            name="StopLossReinsurerRenewalDate"
                            value={values.StopLossReinsurerRenewalDate}
                            onChange={handleChange}
                            isInvalid={
                              touched.StopLossReinsurerRenewalDate &&
                              errors.StopLossReinsurerRenewalDate
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.StopLossReinsurerRenewalDate}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="gap-3 d-block">
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="mb-1"
                            style={Fontstyling.label}
                          >
                            ISL Limit / Pooling Point
                            <Required />
                          </Form.Label>
                          <Form.Control
                            className="rounded-0 py-1 mb-2"
                            style={Fontstyling.label}
                            type="text"
                            placeholder="ISL Limit / Pooling Point"
                            name="ISLLimitPoolingPoint"
                            value={values.ISLLimitPoolingPoint}
                            onChange={handleChange}
                            isInvalid={
                              touched.ISLLimitPoolingPoint &&
                              errors.ISLLimitPoolingPoint
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.ISLLimitPoolingPoint}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Analytics Funding
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="AnalyticsFunding"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.AnalyticsFunding}
                            isInvalid={
                              touched.AnalyticsFunding &&
                              errors.AnalyticsFunding
                            }
                          >
                            <option value={""}>Select Analytics Funding</option>
                            {DropdownData?.AnalyticsFunding.sort().map(
                              (item, index) => (
                                <option
                                  key={index}
                                  value={item.AnalyticsFundingName}
                                >
                                  {item.AnalyticsFundingName}
                                </option>
                              )
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.AnalyticsFunding}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Clinical Consulting
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="ClinicalConsulting"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.ClinicalConsulting}
                            isInvalid={
                              touched.ClinicalConsulting &&
                              errors.ClinicalConsulting
                            }
                          >
                            <option value={""}>
                              Select Clinical Consulting
                            </option>
                            {[
                              { value: "Yes", label: "Yes" },
                              { value: "No", label: "No" },
                            ]
                              .sort()
                              .map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item.label}
                                </option>
                              ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.ClinicalConsulting}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="gap-3 d-block">
                    <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Rx Vendor
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="RxVendor"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.RxVendor}
                            isInvalid={
                              touched.RxVendor &&
                              errors.RxVendor
                            }
                          >
                            <option value={""}>Select Vendor</option>
                            {DropdownData?.VendorList.sort().map(
                              (item, index) => (
                                <option
                                  key={index}
                                  value={item}
                                >
                                  {item}
                                </option>
                              )
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.RxVendor}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      {[
                        {
                          label: "Rx Claims Historical/Ongoing Time Period",
                          value: "RxClaimsHistoricalOngoingTimePeriod",
                          isRequired: true,
                        },
                        {
                          label: "Rx Contact Name",
                          value: "RxContactName",
                          isRequired: true,
                        },
                        {
                          label: "Rx Contact E-mail",
                          value: "RxContactEMail",
                          isRequired: true,
                        },
                        {
                          label: "Rx Contact Phone",
                          value: "RxContactPhone",
                          isRequired: true,
                        },
                      ].map(({ label, value }) => {
                        if (value === "RxClaimsHistoricalOngoingTimePeriod") {
                          return (
                            <Col>
                              <Form.Group className="mb-2">
                                <Form.Label
                                  className="text-nowrap mb-1"
                                  style={Fontstyling.label}
                                >
                                  {label}
                                  <Required />
                                  <img
                                    data-tip="Please list the dates of claims information you're wanting/expecting to receive from
                             the pharmacy carrier (i.e. 1/1/2020 - current, 1/1/2020 - 12/31/2022, etc.)"
                                    src={require("../../assets/icon/Question_mark_back.png")}
                                    style={{ height: 15, marginLeft: 3 }}
                                  />
                                </Form.Label>
                                <DateRangePicker
                                  showOneCalendar
                                  placement="auto"
                                  placeholder="mm/dd/yyyy ~ mm/dd/yyyy"
                                  name="RxClaimsHistoricalOngoingTimePeriod"
                                  style={{
                                    border:
                                      errors.RxClaimsHistoricalOngoingTimePeriod &&
                                      touched.RxClaimsHistoricalOngoingTimePeriod
                                        ? "1px solid #dc3545"
                                        : "1px solid #dee2e6",
                                  }}
                                  editable={false}
                                  value={values[value]}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "RxClaimsHistoricalOngoingTimePeriod",
                                      e
                                    );
                                  }}
                                  onBlur={handleBlur}
                                  format="MM-dd-yyyy"
                                />
                                {errors.RxClaimsHistoricalOngoingTimePeriod &&
                                  touched.RxClaimsHistoricalOngoingTimePeriod && (
                                    <Form.Label
                                      className="text-nowrap fw-bold"
                                      style={Fontstyling.errorlabel}
                                    >
                                      {
                                        errors.RxClaimsHistoricalOngoingTimePeriod
                                      }
                                    </Form.Label>
                                  )}
                              </Form.Group>
                            </Col>
                          );
                        } else {
                          return (
                            <Col>
                              <Form.Group className="text-nowrap mb-2">
                                <Form.Label
                                  className="text-nowrap mb-1"
                                  style={Fontstyling.label}
                                >
                                  {label}
                                  <Required />
                                </Form.Label>
                                <Form.Control
                                  name={value}
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values[value]}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={touched[value] && errors[value]}
                                  type="text"
                                  placeholder={label}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors[value]}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          );
                        }
                      })}
                    </Row>
                    <Row className="gap-3 d-block">
                      {[
                        {
                          label: "Formulary Name 1",
                          value: "FormularyName1",
                          isRequired: false,
                        },
                        {
                          label: "Formulary Name 2",
                          value: "FormularyName2",
                          isRequired: false,
                        },
                      ].map(({ label, value, isRequired }) => (
                        <Col>
                          <Form.Group className="text-nowrap mb-2">
                            <Form.Label
                              className="text-nowrap mb-1"
                              style={Fontstyling.label}
                            >
                              {label}
                              {isRequired && <Required />}
                              <img
                                data-tip="(Optional) - If Selected, Please confirm the Plan Type,
                             followed by, Formulary Name (i.e. PPO, VALUE PLUS FORMULARY)"
                                src={require("../../assets/icon/Question_mark_back.png")}
                                style={{ height: 15, marginLeft: 3 }}
                              />
                            </Form.Label>
                            <Form.Control
                              name={value}
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values[value]}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched[value] && errors[value]}
                              type="text"
                              placeholder={label}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors[value]}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      ))}
                    </Row>
                    <Row className="gap-3 d-block">
                    <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Other Vendor
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="OtherVendor"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.OtherVendor}
                            isInvalid={
                              touched.OtherVendor &&
                              errors.OtherVendor
                            }
                          >
                            <option value={""}>Select Vendor</option>
                            {DropdownData?.VendorList.sort().map(
                              (item, index) => (
                                <option
                                  key={index}
                                  value={item}
                                >
                                  {item}
                                </option>
                              )
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.OtherVendor}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      {[
                        {
                          label: "Other Contact Name",
                          value: "OtherContactName",
                          isRequired: true,
                        },
                        {
                          label: "Other Contact E-mail",
                          value: "OtherContactEMail",
                          isRequired: true,
                        },
                        {
                          label: "Other Contact Phone",
                          value: "OtherContactPhone",
                          isRequired: true,
                        },
                      ].map(({ label, value }) => (
                        <Col>
                          <Form.Group className="text-nowrap mb-2">
                            <Form.Label
                              className="text-nowrap mb-1"
                              style={Fontstyling.label}
                            >
                              {label}
                              <Required />
                            </Form.Label>
                            <Form.Control
                              name={value}
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values[value]}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched[value] && errors[value]}
                              type="text"
                              placeholder={label}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors[value]}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      ))}
                    </Row>
                    <Row className="gap-3 d-block">
                    <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                           Dental Vendor
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="DentalVendor"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.DentalVendor}
                            isInvalid={
                              touched.DentalVendor &&
                              errors.DentalVendor
                            }
                          >
                            <option value={""}>Select Vendor</option>
                            {DropdownData?.VendorList.sort().map(
                              (item, index) => (
                                <option
                                  key={index}
                                  value={item}
                                >
                                  {item}
                                </option>
                              )
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.DentalVendor}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      {[
                        {
                          label: "Dental Contact Name",
                          value: "DentalContactName",
                          isRequired: true,
                        },
                        {
                          label: "Dental Contact E-mail",
                          value: "DentalContactEMail",
                          isRequired: true,
                        },
                        {
                          label: "Dental Contact Phone",
                          value: "DentalContactPhone",
                          isRequired: true,
                        },
                      ].map(({ label, value }) => (
                        <Col>
                          <Form.Group className="text-nowrap mb-2">
                            <Form.Label
                              className="text-nowrap mb-1"
                              style={Fontstyling.label}
                            >
                              {label}
                              <Required />
                            </Form.Label>
                            <Form.Control
                              name={value}
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values[value]}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched[value] && errors[value]}
                              type="text"
                              placeholder={label}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors[value]}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      ))}
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Dental Funding Type
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="DentalFundingType"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.DentalFundingType}
                            isInvalid={
                              touched.DentalFundingType &&
                              errors.DentalFundingType
                            }
                          >
                            <option value={""}>
                              Select Dental Funding Type
                            </option>
                            {DropdownData?.DentalAndVisionFundingType.map(
                              (item, index) => (
                                <option
                                  key={index}
                                  value={item.DentalFundingName}
                                >
                                  {item.DentalFundingName}
                                </option>
                              )
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.DentalFundingType}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="gap-3 d-block">
                    <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                           Vision Vendor
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="VisionVendor"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.VisionVendor}
                            isInvalid={
                              touched.VisionVendor &&
                              errors.VisionVendor
                            }
                          >
                            <option value={""}>Select Vendor</option>
                            {DropdownData?.VendorList.sort().map(
                              (item, index) => (
                                <option
                                  key={index}
                                  value={item}
                                >
                                  {item}
                                </option>
                              )
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.VisionVendor}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      {[
                        {
                          label: "Vision Contact Name",
                          value: "VisionContactName",
                          isRequired: true,
                        },
                        {
                          label: "Vision Contact E-mail",
                          value: "VisionContactEMail",
                          isRequired: true,
                        },
                        {
                          label: "Vision Contact Phone",
                          value: "VisionContactPhone",
                          isRequired: true,
                        },
                      ].map(({ label, value }) => (
                        <Col>
                          <Form.Group className="text-nowrap mb-2">
                            <Form.Label
                              className="text-nowrap mb-1"
                              style={Fontstyling.label}
                            >
                              {label}
                              <Required />
                            </Form.Label>
                            <Form.Control
                              name={value}
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values[value]}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched[value] && errors[value]}
                              type="text"
                              placeholder={label}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors[value]}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      ))}
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Vision Funding Type
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="VisionFundingType"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.VisionFundingType}
                            isInvalid={
                              touched.VisionFundingType &&
                              errors.VisionFundingType
                            }
                          >
                            <option value={""}>
                              Select Vision Funding Type
                            </option>
                            {DropdownData?.DentalAndVisionFundingType.map(
                              (item, index) => (
                                <option
                                  key={index}
                                  value={item.DentalFundingName}
                                >
                                  {item.DentalFundingName}
                                </option>
                              )
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.VisionFundingType}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="gap-3 d-block">
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Benefits Renewal Date
                            <Required />
                            <img
                              data-tip="May be different than the stop loss / reinsurer renewal date"
                              src={require("../../assets/icon/Question_mark_back.png")}
                              style={{ height: 15, marginLeft: 3 }}
                            />
                          </Form.Label>
                          <Form.Control
                            name="BenefitsRenewalDate"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.BenefitsRenewalDate}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.BenefitsRenewalDate &&
                              errors.BenefitsRenewalDate
                            }
                            type="date"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.BenefitsRenewalDate}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      {[
                        {
                          label: "Est. EE Headcount",
                          value: "EstEEHeadcount",
                          isRequired: true,
                        },
                        {
                          label: "Est. Mbr Headcount",
                          value: "EstMbrHeadcount",
                          isRequired: true,
                        },
                      ].map(({ label, value }) => (
                        <Col>
                          <Form.Group className="text-nowrap mb-2">
                            <Form.Label
                              className="text-nowrap mb-1"
                              style={Fontstyling.label}
                            >
                              {label}
                              <Required />
                            </Form.Label>
                            <Form.Control
                              name={value}
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values[value]}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched[value] && errors[value]}
                              type="text"
                              placeholder={label}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors[value]}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      ))}
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Company Size
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="CompanySize"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.CompanySize}
                            isInvalid={
                              touched.CompanySize && errors.CompanySize
                            }
                          >
                            <option value={""}>Select Company Size</option>
                            {DropdownData?.CompanySize.sort().map(
                              (item, index) => (
                                <option
                                  value={item.CompanySizeName}
                                  key={item.CompanySizeID}
                                >
                                  {item.CompanySizeName}
                                </option>
                              )
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.CompanySize}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="gap-3 d-block">
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            Artemis Exp. Date
                            <Required />
                          </Form.Label>
                          <Form.Control
                            name="ArtemisExpDate"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.ArtemisExpDate}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.ArtemisExpDate && errors.ArtemisExpDate
                            }
                            type="date"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.ArtemisExpDate}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      {[
                        {
                          label: "Transition Status",
                          value: "TransitionStatus",
                          isRequired: true,
                        },
                        {
                          label: "Implementation Status",
                          value: "ImplementationStatus",
                          isRequired: true,
                        },
                        {
                          label: "Termed Artemis / No Previous System",
                          value: "TermedArtemisNoPreviousSystem",
                          isRequired: true,
                        },
                        {
                          label: "EOM Deadline / Impl.",
                          value: "EOMDeadlineImpl",
                          isRequired: true,
                        },
                      ].map(({ label, value }) => (
                        <Col>
                          <Form.Group className="text-nowrap mb-2">
                            <Form.Label
                              className="text-nowrap mb-1"
                              style={Fontstyling.label}
                            >
                              {label}
                              <Required />
                            </Form.Label>
                            <Form.Control
                              name={value}
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values[value]}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched[value] && errors[value]}
                              type="text"
                              placeholder={label}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors[value]}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      ))}
                    </Row>
                    <Row className="gap-3 d-block">
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            CGT Notified?
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="CGTNotified"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            value={values.CGTNotified}
                            isInvalid={
                              touched.CGTNotified && errors.CGTNotified
                            }
                          >
                            <option value="">-- Select --</option>
                            {["Yes", "No"].map((item, index) => (
                              <option
                                value={item.toLocaleLowerCase()}
                                key={index}
                              >
                                {item}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.CGTNotified}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                            CGT Date (Completed)
                            <Required />
                          </Form.Label>
                          <Form.Control
                            name="CGTDateCompleted"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.CGTDateCompleted}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.CGTDateCompleted &&
                              errors.CGTDateCompleted
                            }
                            type="date"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.CGTDateCompleted}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="gap-3 d-block">
                      {[
                        {
                          label: "CGT Notice Eligibility",
                          value: "CGTNoticeEligibility",
                          isRequired: true,
                        },
                        {
                          label: "CGT Notice Medical",
                          value: "CGTNoticeMedical",
                          isRequired: true,
                        },
                        {
                          label: "CGT Notice Rx",
                          value: "CGTNoticeRx",
                          isRequired: true,
                        },
                        {
                          label: "CGT Notice Other",
                          value: "CGTNoticeOther",
                          isRequired: true,
                        },
                        {
                          label: "CGT Notice Dental",
                          value: "CGTNoticeDental",
                          isRequired: true,
                        },
                        {
                          label: "CGT Notice Vision",
                          value: "CGTNoticeVision",
                          isRequired: true,
                        },
                      ].map(({ label, value }) => (
                        <Col>
                          <Col>
                            <Form.Group className="text-nowrap mb-2">
                              <Form.Label
                                className="text-nowrap mb-1"
                                style={Fontstyling.label}
                              >
                                {label}
                                <Required />
                              </Form.Label>
                              <Form.Select
                                className="rounded-0 mb-2"
                                style={Fontstyling.dropdown_label}
                                name={value}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                                onBlur={handleBlur}
                                value={values[value]}
                                isInvalid={touched[value] && errors[value]}
                              >
                                <option value="">-- Select --</option>
                                {["Yes", "No"].map((item, index) => (
                                  <option
                                    value={item.toLocaleLowerCase()}
                                    key={index}
                                  >
                                    {item}
                                  </option>
                                ))}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                {errors[value]}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Col>
                      ))}
                    </Row>
                    <Row className="gap-3 d-block">
                      {[
                        {
                          label: "Wrap Network (Sub Contracted Network)",
                          value: "WrapNetworkSubContractedNetwork",
                          isRequired: true,
                        },
                        {
                          label: "Domestic Incentive?",
                          value: "DomesticIncentive",
                          isRequired: true,
                        },
                        {
                          label: "ASL Limit / Pooling Point",
                          value: "ASLLimitPoolingPoint",
                          isRequired: true,
                        },
                        {
                          label: "Analytics Funding Contact Name",
                          value: "AnalyticsFundingContactName",
                          isRequired: true,
                        },
                        {
                          label: "Analytics Funding Contact E-Mail Address",
                          value: "AnalyticsFundingContactEMailAddress",
                          isRequired: true,
                        },
                        {
                          label: "Analytics Funding Contact Phone Number",
                          value: "AnalyticsFundingContactPhoneNumber",
                          isRequired: true,
                        },
                        {
                          label:
                            "2nd Eligibility Historical/Ongoing Time Period",
                          value:
                            "SecondndEligibilityHistoricalOngoingTimePeriod",
                          isRequired: true,
                        }].map(({ label, value }) => {
                          if (
                            value ===
                            "SecondndEligibilityHistoricalOngoingTimePeriod"
                          ) {
                            return (
                              <Col>
                                <Form.Group className="mb-2">
                                  <Form.Label
                                    className="text-nowrap mb-1"
                                    style={Fontstyling.label}
                                  >
                                    {label}
                                    <Required />
                                  </Form.Label>
                                  <DateRangePicker
                                    placement="auto"
                                    showOneCalendar
                                    placeholder="mm/dd/yyyy ~ mm/dd/yyyy"
                                    name="SecondndEligibilityHistoricalOngoingTimePeriod"
                                    style={{
                                      border:
                                        errors.SecondndEligibilityHistoricalOngoingTimePeriod &&
                                        touched.SecondndEligibilityHistoricalOngoingTimePeriod
                                          ? "1px solid #dc3545"
                                          : "1px solid #dee2e6",
                                      zIndex: 999,
                                    }}
                                    editable={false}
                                    value={values[value]}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "SecondndEligibilityHistoricalOngoingTimePeriod",
                                        e
                                      );
                                    }}
                                    onBlur={handleBlur}
                                    format="MM-dd-yyyy"
                                  />
                                  {errors.SecondndEligibilityHistoricalOngoingTimePeriod &&
                                    touched.SecondndEligibilityHistoricalOngoingTimePeriod && (
                                      <Form.Label
                                        className="text-nowrap fw-bold"
                                        style={Fontstyling.errorlabel}
                                      >
                                        {
                                          errors.SecondndEligibilityHistoricalOngoingTimePeriod
                                        }
                                      </Form.Label>
                                    )}
                                </Form.Group>
                              </Col>
                            );
                          } else {
                            return (
                              <Col>
                                <Form.Group className="text-nowrap mb-2">
                                  <Form.Label
                                    className="text-nowrap mb-1"
                                    style={Fontstyling.label}
                                  >
                                    {label}
                                    <Required />
                                  </Form.Label>
                                  <InputGroup>
                                    {value === "ASLLimitPoolingPoint" && (
                                      <InputGroup.Text className="py-0 fw-bold">
                                        $
                                      </InputGroup.Text>
                                    )}
                                    <Form.Control
                                      name={value}
                                      className="py-1 rounded-0"
                                      style={Fontstyling.label}
                                      value={values[value]}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      isInvalid={touched[value] && errors[value]}
                                      type={
                                        value === "ASLLimitPoolingPoint"
                                          ? "number"
                                          : "text"
                                      }
                                      step={
                                        value === "ASLLimitPoolingPoint"
                                          ? "any"
                                          : undefined
                                      }
                                      placeholder={
                                        value === "ASLLimitPoolingPoint"
                                          ? ""
                                          : label
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors[value]}
                                    </Form.Control.Feedback>
                                  </InputGroup>
                                </Form.Group>
                              </Col>
                            );
                          }
                        })}
                      </Row>
                      <Row className="gap-3 d-block">
                    <Col>
                        <Form.Group className="text-nowrap mb-2">
                          <Form.Label
                            className="text-nowrap mb-1"
                            style={Fontstyling.label}
                          >
                           Other Vendor 2
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0 mb-2"
                            style={Fontstyling.dropdown_label}
                            name="OtherVendor2"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.OtherVendor2}
                            isInvalid={
                              touched.OtherVendor2 &&
                              errors.OtherVendor2
                            }
                          >
                            <option value={""}>Select Vendor</option>
                            {DropdownData?.VendorList.sort().map(
                              (item, index) => (
                                <option
                                  key={index}
                                  value={item}
                                >
                                  {item}
                                </option>
                              )
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.OtherVendor2}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                        {[{
                          label: "Other Contact Name 2",
                          value: "OtherContactName2",
                          isRequired: true,
                        },
                        {
                          label: "Other Contact Email 2",
                          value: "OtherContactEmail2",
                          isRequired: true,
                        },
                        {
                          label: "Other Contact Phone 2",
                          value: "OtherContactPhone2",
                          isRequired: true,
                        },
                      ].map(({ label, value }) => {
                          return (
                            <Col>
                              <Form.Group className="text-nowrap mb-2">
                                <Form.Label
                                  className="text-nowrap mb-1"
                                  style={Fontstyling.label}
                                >
                                  {label}
                                  <Required />
                                </Form.Label>
                                <InputGroup>
                                 
                                  <Form.Control
                                    name={value}
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    value={values[value]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched[value] && errors[value]}
                                    type={
                                      "text"
                                    }
                                    placeholder={
                                      label
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors[value]}
                                  </Form.Control.Feedback>
                                </InputGroup>
                              </Form.Group>
                            </Col>
                          );
                        
                      })}
                    </Row>
                    <Row className="gap-3 d-block">
                      {[
                        {
                          label: "SL / Carrier Funding Notice",
                          value: "SLCarrierFundingNotice",
                          isRequired: true,
                        },
                        {
                          label: "Client Email Received",
                          value: "ClientEmailReceived",
                          isRequired: true,
                        },
                        {
                          label: "NDA Received",
                          value: "NDAReceived",
                          isRequired: true,
                        },
                        {
                          label: "LOI Received",
                          value: "LOIReceived",
                          isRequired: true,
                        },
                      ].map(({ label, value }) => (
                        <Col>
                          <Form.Group className="text-nowrap mb-2">
                            <Form.Label
                              className="text-nowrap mb-1"
                              style={Fontstyling.label}
                            >
                              {label}
                              <Required />
                            </Form.Label>
                            <Form.Select
                              className="rounded-0 mb-2"
                              style={Fontstyling.dropdown_label}
                              name={value}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              onBlur={handleBlur}
                              value={values[value]}
                              isInvalid={touched[value] && errors[value]}
                            >
                              <option value="">-- Select --</option>
                              {["Yes", "No"].map((item, index) => (
                                <option
                                  value={item.toLocaleLowerCase()}
                                  key={index}
                                >
                                  {item}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors[value]}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      ))}
                    </Row>
                    <Row className="gap-3 d-block">
                      {[
                        {
                          label: "Go Live Date",
                          value: "GoLiveDate",
                          isRequired: true,
                        },
                        {
                          label: "Innovu Term Date",
                          value: "InnovuTermDate",
                          isRequired: true,
                        },
                        {
                          label: "Notes",
                          value: "Notes",
                          isRequired: true,
                        },
                      ].map(({ label, value }) => (
                        <Col>
                          <Form.Group className="text-nowrap mb-2">
                            <Form.Label
                              className="text-nowrap mb-1"
                              style={Fontstyling.label}
                            >
                              {label}
                              <Required />
                            </Form.Label>
                            <Form.Control
                              name={value}
                              as={value === "Notes" ? "textarea" : undefined}
                              rows={value === "Notes" ? 2 : undefined}
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values[value]}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched[value] && errors[value]}
                              type={value === "Notes" ? undefined : "date"}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors[value]}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      ))}
                    </Row>

                    {/* <div className="text-end">
          <Button
            style={Fontstyling.savebutton}
            type="submit"
            onClick={() => setIsFocus(!isFocus)}
          >
            Save
          </Button>
        </div> */}
                  </>
                )}
                <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                  <button
                    ref={buttonRef}
                    style={Fontstyling.savebutton}
                    type="submit"
                    onClick={() => setIsFocus(!isFocus)}
                  >
                    save
                  </button>
                  <button
                    style={Fontstyling.cancelbutton}
                    type="reset"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </Form>
            </div>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add New Group
        </CustomButton>
      </div>

      <div>
        <div className="mt-2">
          {csvData.length <= 1 ? (
            <div
              style={{
                ...Fontstyling.addnewbutton,
                color: "white",
                textDecoration: "none",
                opacity: 0.5,
                width: "fit-content",
              }}
              className="d-flex align-items-end justify-content-center"
            >
              <SaveAltIcon className="me-2" />
              <div>Export to CSV</div>
            </div>
          ) : (
            <CSVLink
              filename={fileName}
              data={csvData}
              style={{
                ...Fontstyling.addnewbutton,
                color: "white",
                textDecoration: "none",
                width: "fit-content",
              }}
              className="d-flex align-items-end justify-content-center"
            >
              <SaveAltIcon className="me-2" />
              <div>Export to CSV</div>
            </CSVLink>
          )}
        </div>
        <LocalizationProvider dateAdapter={AdapterDayjs} >
          <CustomReactMaterialTable
            data={data}
            columns={columns}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            setWitchAction={setWitchAction}
            setSelectedRowData={setSelectedRowData}
            setShowModal={setShowModal}
            isLoading={isLoading}
            isExport={false}
            isEdit={true}
            isDelete={true}
            page={"grouplist"}
          />
          </LocalizationProvider>
      </div>
    </>
  );
};

export default ListOfCDTGroup;
